import { defineI18nConfig } from '#imports';

export default defineI18nConfig(() => ({
  // fallbackLocale: DEFAULT_LOCALE,
  silentTranslationWarn: true,
  warnHtmlMessage: false,
  missing: (_: string, key: string) => {
    return key;
  }
}));
